import { TxpDatapoint } from 'txp-data';
import populateErrorCardDataPoint from '../../utils/telemetry/populateErrorCardDatapoint';
import TxpDataPointNames from '../../store/schema/telemetry/TxpDataPointNames';
import TxpEntitiesState from 'txp-data/lib/schema/innerSchema/TxpEntitiesState';

/**
 * Handler for events to follow after TXP error card is shown. Populate the error card
 * datapoint and call the callback function passed as argument with the datapoint
 */
export default function onErrorCardShownHandler(
    entityNamesMap: number,
    txpEntitiesState: TxpEntitiesState,
    onErrorCardShown: (txpDatapoint: TxpDatapoint, datapointName: string) => void
) {
    if (onErrorCardShown) {
        const dataPoint = populateErrorCardDataPoint(entityNamesMap, txpEntitiesState);
        onErrorCardShown(dataPoint, TxpDataPointNames.TXPErrorCard);
    }
}
